module.exports = __webpack_public_path__ + "BuckProud-f04e25f152081329b5249ecaeb956110.svg";